import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

// Heroicons solid "pause" (rounded-pill bars) - matches Figma's asset exactly, replacing the
// earlier hand-drawn thin-stroke version.
const Pause = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ size, variant, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 10.5C13.5 9.67157 14.1716 9 15 9H18C18.8284 9 19.5 9.67157 19.5 10.5V37.5C19.5 38.3284 18.8284 39 18 39H15C14.6022 39 14.2206 38.842 13.9393 38.5607C13.658 38.2794 13.5 37.8978 13.5 37.5L13.5 10.5ZM28.5 10.5C28.5 9.67157 29.1716 9 30 9H33C33.3978 9 33.7794 9.15804 34.0607 9.43934C34.342 9.72064 34.5 10.1022 34.5 10.5V37.5C34.5 38.3284 33.8284 39 33 39H30C29.1716 39 28.5 38.3284 28.5 37.5V10.5Z"
      fill="currentColor"
    />
  </svg>
);

export default Pause;
